import * as actionTypes from '../constants/userActionTypes';

const defaultState = {
    messages: [],
    allProjectMembers: [],
    loading: false,
    errors: {}
}

/**
 * function for user get chats reducer
 * @param {object} action action response
 * @param {function} getChatReducer chats chat reducer function
 */
export const chatsReducers = (state = defaultState, action = {}) => {
    switch (action.type) {
        case actionTypes.GET_CHAT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_CHAT_SUCCESS:
            return {
                ...state,
                loading: false,
                messages: action.payload.data
            }

        case actionTypes.GET_CHAT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        // SEND MESSAGE
        case actionTypes.SEND_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                errors: {},
                messages: [...state.messages, action.payload.data],
            }
        case actionTypes.SEND_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_MESSAGE:
            return {
                ...state,
                error: null,
                message: null
            }
        // CHAT USERS
        case actionTypes.GET_CHAT_USERS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_CHAT_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                users: action.payload.data
            }

        case actionTypes.GET_CHAT_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default: return state
    }
}